/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import styled from "styled-components";

export const FullWidthContainer = styled.div`
  width: 100%;
`;
